/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetMeResponse } from '../../models/get-me-response';

export interface UserServiceGetMe$Params {
}

export function userServiceGetMe(http: HttpClient, rootUrl: string, params?: UserServiceGetMe$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMeResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceGetMe.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMeResponse>;
    })
  );
}

userServiceGetMe.PATH = '/api/v3/gateway/user/s/me';
